import axios from 'axios'

const api = axios.create({
    baseURL: `${process.env.VUE_APP_URL_SERVER}/api/`,
    withCredentials: true
})

// interceptor para tratar 401
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // redireciona para login central
      window.location.href = `${process.env.VUE_APP_API_LOGIN_REDIRECT}/auth/?redirect=${encodeURIComponent(window.location.href)}`
    }
    return Promise.reject(error)
  }
)

export default () => api